export default __webpack_public_path__ + "static/media/app-store.57b746a6.png";